/* eslint-disable import/no-unresolved,import/no-extraneous-dependencies */
import { useCallback, useEffect, useRef, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useBuySellInputCreateOrder } from '.';
import useBuilderMultiFormLogic from './builderMultiFormLogic';
import { useBuilderTooltips } from '../../hooks/useBuilderTooltips';
import { TRADE_METHODS } from '../../constants';
import { ORDER_TYPES } from '../../constants/manualTrade';
import { transformInstrumentId } from '../../hooks/symbol';
import { changeBuilderActiveCurrency, getBuilderChartDataRequest, resetBuilderOrdersTables } from '../../redux/actions';
import { resetBuilderSimulationData } from '../../redux/actions/builderActions';

// TS-7463 トレードに取引手法「自動売買」を追加する共通部分_開発_トレードに取引手法「自動売買」を追加する
// 質問票より「値幅設定の「Past 1year Range of fluctuation」を「Past three months Range of fluctuation」に変更いただきたいです。」
// 3か月前＝指定日から90日を引いた日付
const TRADE_AP_CHART_DATA_TERM = { value: 90, unit: 'day' };

export const useTradeAPLogic = (submitCallback, reset) => {
  const multiFormLogic = useBuilderMultiFormLogic(submitCallback, reset, 'tradeAP');
  const tooltip = useBuilderTooltips(false, true);
  const dispatch = useDispatch();

  const serviceId = useSelector((state) => state.auth.serviceId);
  const curInstrumentIdM = useSelector((state) => state.manualTrade.selectedInstrumentId[serviceId]);
  const preInstrumentIdM = useRef(null);

  const hasChangeInstrumentIdM = curInstrumentIdM !== preInstrumentIdM.current;

  useEffect(() => {
    // Manual to AP
    if (hasChangeInstrumentIdM && curInstrumentIdM) {
      const instrumentIdAP = transformInstrumentId(TRADE_METHODS.AP.ID, curInstrumentIdM, serviceId);
      if (instrumentIdAP) {
        dispatch(changeBuilderActiveCurrency({ activeCurrency: instrumentIdAP }));
        dispatch(getBuilderChartDataRequest({ term: TRADE_AP_CHART_DATA_TERM }));
      }
    }
  }, [dispatch, serviceId, hasChangeInstrumentIdM, curInstrumentIdM]);

  const [buySellM, changeBuySellM] = useBuySellInputCreateOrder(ORDER_TYPES.TRADE_AP.name);
  const buySellAP = multiFormLogic.buySell.get;
  const changeBuySellAP = multiFormLogic.buySell.set;
  const wrappedChangeBuySellAP = useCallback(
    (value) => {
      // AP to Manual
      changeBuySellAP(value);
      changeBuySellM(value);
    },
    [changeBuySellAP, changeBuySellM],
  );
  const submitOrg = multiFormLogic.submit.handler;
  const wrappedSubmit = useCallback(() => {
    dispatch(resetBuilderOrdersTables());
    dispatch(resetBuilderSimulationData());
    submitOrg();
  }, [dispatch, submitOrg]);

  useEffect(() => {
    if (buySellM !== buySellAP) {
      // Manual to AP
      changeBuySellAP(buySellM);
    }
  }, [buySellM, buySellAP, changeBuySellAP]);

  useEffect(() => {
    preInstrumentIdM.current = curInstrumentIdM;
  }, [curInstrumentIdM]);

  return useMemo(
    () => ({
      ...multiFormLogic,
      buySell: {
        ...multiFormLogic.buySell,
        set: wrappedChangeBuySellAP,
      },
      quantity: {
        ...multiFormLogic.quantity,
        tooltipMessage: tooltip.quantity.tooltipMessage,
      },
      submit: {
        ...multiFormLogic.submit,
        handler: wrappedSubmit,
      },
    }),

    [multiFormLogic, tooltip, wrappedChangeBuySellAP, wrappedSubmit],
  );
};
